export var AuthFeatures;
(function (AuthFeatures) {
    AuthFeatures["Mode: Find"] = "Mode: Find";
    AuthFeatures["Mode: Develop"] = "Mode: Develop";
    AuthFeatures["Mode: Design"] = "Mode: Design";
    AuthFeatures["Mode: Build"] = "Mode: Build";
    AuthFeatures["Mode: Comply"] = "Mode: Comply";
    AuthFeatures["Mode: Showcase"] = "Mode: Showcase";
    AuthFeatures["Mode: eCheck"] = "Mode: eCheck";
    AuthFeatures["Mode: City"] = "Mode: City";
    AuthFeatures["Vancouver"] = "Vancouver";
    AuthFeatures["Search Tab"] = "Search Tab";
    AuthFeatures["Merged Sites"] = "Merged Sites";
    AuthFeatures["Rapid Assess"] = "Rapid Assess";
    AuthFeatures["Can Purchase Single Sites"] = "Can Purchase Single Sites";
    AuthFeatures["Filter Tab"] = "Filter Tab";
    AuthFeatures["Intended Use"] = "Intended Use";
    AuthFeatures["Permitted Use Flags"] = "Permitted Use Flags";
    AuthFeatures["Filter: strata counts"] = "Filter: strata counts";
    AuthFeatures["Library Tab"] = "Library Tab";
    AuthFeatures["All Layers except 3D"] = "All Layers except 3D";
    AuthFeatures["3D Buildings Layer"] = "3D Buildings Layer";
    AuthFeatures["Custom Branding"] = "Custom Branding";
    AuthFeatures["Direct Mail"] = "Direct Mail";
    AuthFeatures["Bulk Scenario Creation"] = "Bulk Scenario Creation";
    AuthFeatures["Site Export"] = "Site Export";
    AuthFeatures["Precincts"] = "Precincts";
    AuthFeatures["Domain"] = "Domain";
    AuthFeatures["Commercial Real Estate"] = "Commercial Real Estate";
    AuthFeatures["CoreLogic"] = "CoreLogic";
    AuthFeatures["CoreLogic Free"] = "CoreLogic Free";
    AuthFeatures["CoreLogic Signin"] = "CoreLogic Signin";
    AuthFeatures["Cordell"] = "Cordell";
    AuthFeatures["Cordell Free"] = "Cordell Free";
    AuthFeatures["Cordell Signin"] = "Cordell Signin";
    AuthFeatures["Cordell CONTACTS"] = "Cordell CONTACTS";
    AuthFeatures["Domain Advanced"] = "Domain Advanced";
    AuthFeatures["Domain Advanced Contacts"] = "Domain Advanced Contacts";
    AuthFeatures["BCI"] = "BCI";
    AuthFeatures["Bci CONTACTS"] = "Bci CONTACTS";
    AuthFeatures["Bci Signin"] = "Bci Signin";
    AuthFeatures["BCI US"] = "BCI US";
    AuthFeatures["BCI US Contacts"] = "BCI US Contacts";
    AuthFeatures["Export Addon Data"] = "Export Addon Data";
    AuthFeatures["Addon: Melbourne DA"] = "Addon: Melbourne DA";
    AuthFeatures["Addon: DNA"] = "Addon: DNA";
    AuthFeatures["Value Australia"] = "Value Australia";
    AuthFeatures["Site Risks"] = "Site Risks";
    AuthFeatures["Site Overlays"] = "Site Overlays";
    AuthFeatures["Site Property"] = "Site Property";
    AuthFeatures["Site Details"] = "Site Details";
    AuthFeatures["Full Site Details"] = "Full Site Details";
    AuthFeatures["Upload Sites"] = "Upload Sites";
    AuthFeatures["Measure Tab"] = "Measure Tab";
    AuthFeatures["Estimate Tab"] = "Estimate Tab";
    AuthFeatures["Estate Master"] = "Estate Master";
    AuthFeatures["Site Card"] = "Site Card";
    AuthFeatures["Designer Tab"] = "Designer Tab";
    AuthFeatures["Elevation Tab"] = "Elevation Tab";
    AuthFeatures["Projects Tab"] = "Projects Tab";
    AuthFeatures["Development Potential Reports"] = "Development Potential Reports";
    AuthFeatures["Equifax Land Titles"] = "Equifax Land Titles";
    AuthFeatures["LIR Report"] = "LIR Report";
    AuthFeatures["Static Feasibility"] = "Static Feasibility";
    AuthFeatures["Export Design"] = "Export Design";
    AuthFeatures["Upload Designs"] = "Upload Designs";
    AuthFeatures["Edit Designs"] = "Edit Designs";
    AuthFeatures["Solar Envelope"] = "Solar Envelope";
    AuthFeatures["Cut And Fill"] = "Cut And Fill";
    AuthFeatures["Mass Generate"] = "Mass Generate";
    AuthFeatures["Project Feasibility"] = "Project Feasibility";
    AuthFeatures["Home Designer"] = "Home Designer";
    AuthFeatures["Homes Designer Lite"] = "Homes Designer Lite";
    AuthFeatures["Homes 3d"] = "Homes 3d";
    AuthFeatures["homes management"] = "homes management";
    AuthFeatures["Homes Demo Library"] = "Homes Demo Library";
    AuthFeatures["50 Home Designs"] = "50 Home Designs";
    AuthFeatures["200 Home Designs"] = "200 Home Designs";
    AuthFeatures["500 Home Designs"] = "500 Home Designs";
    AuthFeatures["Unlimited Home Designs"] = "Unlimited Home Designs";
    AuthFeatures["Designer: apartment"] = "Designer: apartment";
    AuthFeatures["Designer: boardinghouse"] = "Designer: boardinghouse";
    AuthFeatures["Designer: carpark"] = "Designer: carpark";
    AuthFeatures["Designer: commercial"] = "Designer: commercial";
    AuthFeatures["Designer: duplex"] = "Designer: duplex";
    AuthFeatures["Designer: hotel"] = "Designer: hotel";
    AuthFeatures["Designer: house"] = "Designer: house";
    AuthFeatures["Designer: manor"] = "Designer: manor";
    AuthFeatures["Designer: masterplan"] = "Designer: masterplan";
    AuthFeatures["Designer: mixeduse"] = "Designer: mixeduse";
    AuthFeatures["Designer: subdivision"] = "Designer: subdivision";
    AuthFeatures["Designer: terrace"] = "Designer: terrace";
    AuthFeatures["Designer: townhouse"] = "Designer: townhouse";
    AuthFeatures["Designer: Willmott Dixon"] = "Designer: Willmott Dixon";
    AuthFeatures["Designer: RoadNetwork"] = "Designer: RoadNetwork";
    AuthFeatures["Designer: Aldar"] = "Designer: Aldar";
    AuthFeatures["Nearmap"] = "Nearmap";
    AuthFeatures["Layer: Zoning"] = "Layer: Zoning";
    AuthFeatures["Layer: DetailedContours2D"] = "Layer: DetailedContours2D";
    AuthFeatures["Layer: MaxBuildHeight"] = "Layer: MaxBuildHeight";
    AuthFeatures["Layer: EstStreetFrontage"] = "Layer: EstStreetFrontage";
    AuthFeatures["Layer: overlay_flood"] = "Layer: overlay_flood";
    AuthFeatures["Layer: overlay_bushfire"] = "Layer: overlay_bushfire";
    AuthFeatures["Layer: overlay_heritage"] = "Layer: overlay_heritage";
    AuthFeatures["Layer: contamination"] = "Layer: contamination";
    AuthFeatures["Layer: infrastructure_electricity"] = "Layer: infrastructure_electricity";
    AuthFeatures["Layer: LotAreaToggle"] = "Layer: LotAreaToggle";
    AuthFeatures["Layer: Contours2D"] = "Layer: Contours2D";
    AuthFeatures["Layer: Contours3D"] = "Layer: Contours3D";
    AuthFeatures["Layer: suburb-boundaries"] = "Layer: suburb-boundaries";
    AuthFeatures["Layer: council-boundaries"] = "Layer: council-boundaries";
    AuthFeatures["Layer: rail-lines"] = "Layer: rail-lines";
    AuthFeatures["Layer: lots-and-road"] = "Layer: lots-and-road";
    AuthFeatures["Layer: poi"] = "Layer: poi";
    AuthFeatures["Layer: Satellite"] = "Layer: Satellite";
    AuthFeatures["Layer: EagleView"] = "Layer: EagleView";
    AuthFeatures["Layer: 3DBuildings"] = "Layer: 3DBuildings";
    AuthFeatures["Layer: Easements"] = "Layer: Easements";
    AuthFeatures["Layer: koala_bio"] = "Layer: koala_bio";
    AuthFeatures["Layer: fire_ant_zones"] = "Layer: fire_ant_zones";
    AuthFeatures["Layer: strata_lots"] = "Layer: strata_lots";
    AuthFeatures["Layer: Other Overlays"] = "Layer: Other Overlays";
    AuthFeatures["Layer: IES"] = "Layer: IES";
    AuthFeatures["Layer: 3d-terrain"] = "Layer: 3d-terrain";
    //Find and Assess
    AuthFeatures["HotSpots: Residential"] = "HotSpots: Residential";
    AuthFeatures["HotSpots: Development sites"] = "HotSpots: Development sites";
    AuthFeatures["HotSpots: Granny Flat"] = "HotSpots: Granny Flat";
    AuthFeatures["Planning: house"] = "Planning: house";
    AuthFeatures["Planning: duplex"] = "Planning: duplex";
    AuthFeatures["Planning: townhouse"] = "Planning: townhouse";
    AuthFeatures["Planning: subdivision"] = "Planning: subdivision";
    AuthFeatures["Planning: apartment"] = "Planning: apartment";
    AuthFeatures["Planning: mixed use"] = "Planning: mixed use";
    AuthFeatures["Planning: commercial"] = "Planning: commercial";
    AuthFeatures["Planning: aged care"] = "Planning: aged care";
    AuthFeatures["Planning: other"] = "Planning: other";
    AuthFeatures["Planning: view all"] = "Planning: view all";
    AuthFeatures["Precedents"] = "Precedents";
    //International
    AuthFeatures["First American"] = "First American";
    AuthFeatures["Realyse"] = "Realyse";
    //Other
    AuthFeatures["grasshopper plugin"] = "grasshopper plugin";
    AuthFeatures["workspace"] = "workspace";
    AuthFeatures["datasets_layers_read"] = "datasets_layers_read";
    AuthFeatures["datasets_layers_write"] = "datasets_layers_write";
    AuthFeatures["Risk Frontier"] = "Risk Frontier";
    AuthFeatures["Planning Document Read"] = "Planning Document Read";
    AuthFeatures["Planning Document Write"] = "Planning Document Write";
    AuthFeatures["Planning Document eCheck Write"] = "Planning Document eCheck Write";
    AuthFeatures["eCheck Submission Mgmt"] = "eCheck Submission Mgmt";
    AuthFeatures["eCheck Submission Approver"] = "eCheck Submission Approver";
    AuthFeatures["Greenfield Management"] = "Greenfield Management";
    AuthFeatures["Building Envelope Management"] = "Building Envelope Management";
    AuthFeatures["Home Design Library Management"] = "Home Design Library Management";
    //Compliance Features
    AuthFeatures["Compliance"] = "Compliance";
    AuthFeatures["Compliance Vic Homes Dashboard"] = "Compliance Vic Homes Dashboard";
    AuthFeatures["Compliance NSW Homes Dashboard"] = "Compliance NSW Homes Dashboard";
    AuthFeatures["Compliance Vancouver Homes Dashboard"] = "Compliance Vancouver Homes Dashboard";
    AuthFeatures["Compliance Victoria"] = "Compliance Victoria";
    AuthFeatures["Compliance Masterplan"] = "Compliance Masterplan";
    AuthFeatures["Compliance Masterplan Mgmt"] = "Compliance Masterplan Mgmt";
    AuthFeatures["Compliance Group Submission"] = "Compliance Group Submission";
    AuthFeatures["Archiland"] = "Archiland";
    //API Features
    AuthFeatures["API"] = "API";
    AuthFeatures["sandbox"] = "sandbox";
    AuthFeatures["full"] = "full";
    AuthFeatures["property report"] = "property report";
    AuthFeatures["property advanced"] = "property advanced";
    AuthFeatures["property essentials"] = "property essentials";
    AuthFeatures["property suggest"] = "property suggest";
    AuthFeatures["property find within geometry"] = "property find within geometry";
    AuthFeatures["property report tools"] = "property report tools";
    AuthFeatures["property map info"] = "property map info";
    AuthFeatures["document order"] = "document order";
    AuthFeatures["document deliver"] = "document deliver";
    AuthFeatures["max bld height geojson"] = "max bld height geojson";
    //Academy features
    AuthFeatures["course builder - RW"] = "course builder - RW";
    AuthFeatures["admin course builder - RW"] = "admin course builder - RW";
    //Admin features
    AuthFeatures["app dashboards - RW"] = "app dashboards - RW";
    AuthFeatures["billing - R"] = "billing - R";
    AuthFeatures["billing - RW"] = "billing - RW";
    AuthFeatures["cart approvals - R"] = "cart approvals - R";
    AuthFeatures["cart approvals - RW"] = "cart approvals - RW";
    AuthFeatures["company users - D"] = "company users - D";
    AuthFeatures["company users - R"] = "company users - R";
    AuthFeatures["company users - W"] = "company users - W";
    AuthFeatures["create cart - R"] = "create cart - R";
    AuthFeatures["create cart - RW"] = "create cart - RW";
    AuthFeatures["dataDashboard - R"] = "dataDashboard - R";
    AuthFeatures["dataDashboard - RW"] = "dataDashboard - RW";
    AuthFeatures["finance reports"] = "finance reports";
    AuthFeatures["generatorDashboard - R"] = "generatorDashboard - R";
    AuthFeatures["logs - R"] = "logs - R";
    AuthFeatures["mark invoice paid"] = "mark invoice paid";
    AuthFeatures["profile - RW"] = "profile - RW";
    AuthFeatures["sales reports - R"] = "sales reports - R";
    AuthFeatures["sales reports - RW"] = "sales reports - RW";
    AuthFeatures["self billing - RW"] = "self billing - RW";
    AuthFeatures["subscription update - R"] = "subscription update - R";
    AuthFeatures["subscription update - RW"] = "subscription update - RW";
    AuthFeatures["super admin - R"] = "super admin - R";
    AuthFeatures["system users - R"] = "system users - R";
    AuthFeatures["system users - RW"] = "system users - RW";
    AuthFeatures["upload documents"] = "upload documents";
    AuthFeatures["users - R"] = "users - R";
    AuthFeatures["users - RW"] = "users - RW";
    AuthFeatures["view documents"] = "view documents";
    //Support features
    AuthFeatures["Training"] = "Training";
})(AuthFeatures || (AuthFeatures = {}));
